import { showLoadingImage } from "./Utility";

 const LoadingScreen = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(216, 214, 214, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1301,
      }}
    >
      {showLoadingImage()}
    </div>
  );
};

export default LoadingScreen;